import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { JournalEntryReportSummaryEntity } from '../../../../api/types/accounting/journal-entries/journal-entry-report-details-response';
import { JournalEntryReportDetailsWithLinesEntity } from '../../../../api/types/accounting/journal-entries/journal-entry-report-details-with-lines-entity';

export const getJournalEntryReportDetailsOperation = async (
  reportId: number,
  setReport: (report: JournalEntryReportSummaryEntity | null) => void,
  setEntries: (entries: JournalEntryReportDetailsWithLinesEntity[]) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getJournalEntryReportDetails(reportId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setReport(res.data.body?.report ?? null);
    setEntries(res.data.body?.entries ?? []);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
